<div class="sidenav-user text-center">
    <button class="setting-primary" [matMenuTriggerFor]="config"><i class="far fa-cog"></i></button>
    <mat-menu #config="matMenu" class="config-menu">
		<h3 class="config-menu-title">Configuración</h3>
		<button mat-menu-item type="button" (click)="onViewProfile()">{{ 'lbl_editar_perfil' | translate : listTraduction.lbl }}</button>
		<a mat-menu-item routerLink="/configuration/change-pwd">{{ 'lbl_contrasenia' | translate : listTraduction.lbl }}</a>
	</mat-menu>
    <ng-container *ngIf="photo !== ''; else letterLogo">
        <div class="user-avatar rounded-circle border border-5 border-alternative">
            <app-image [image]="photo" classImage="img-fluid rounded-circle user-avatar-pic img-pick"></app-image>   
            <h1>xx</h1>         
        </div>
    </ng-container>
    <ng-template #letterLogo>
        <app-image [fullName]="fullName"></app-image>
    </ng-template>    
    <div class="badge-bottom"></div>
    <a routerLink="/home" class="text-decoration-none">
        <h6 class="mt-3 mb-0 text-primary-emphasis sidenav-user-name">{{fullName}}</h6>
    </a>
    <p class="mb-0 sidenav-user-title">{{infoProfile}}</p>
</div>